
/* mega tab menu*/

document.addEventListener('DOMContentLoaded', function() {
    var menuItems = document.querySelectorAll('.mega-tab-menu-col.left .product-section-title');
    var totalMenu = menuItems.length;
    menuItems.forEach(function(item, index) {
        item.addEventListener('mouseover', function() {
            if (totalMenu === index + 1) return false; //last btn,  ignore
            setLeftMenuActive(index);
            setRightContentActive(index);
            // Log the index of the hovered item
            console.log('Hovered item index:', index + 1);
        });
    });

    function setRightContentActive(activeIndex) {
        var contentItems = document.querySelectorAll('.mega-tab-menu-col.right .product-section-outer');
        setDomListActive(contentItems, activeIndex)

    }

    function setLeftMenuActive(activeIndex) {
        var menuItems = document.querySelectorAll('.mega-tab-menu-col.left .product-section-title');
        setDomListActive(menuItems, activeIndex)
    }

    function setDomListActive(domList, activeIndex) {
        domList.forEach(function(item, index) {
            if (activeIndex === index) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }
    

});


// enable slide banner image clickable
document.addEventListener('DOMContentLoaded', function() {
    var slideBanners = document.querySelectorAll('slide-show.main-slideshow .slideshow__slide');
    slideBanners.forEach(function(banner, index) {
        banner.addEventListener('click', function() {
            var slideLink = banner.querySelector('.slideshow__slide-inner .slideshow__slide-content>a');
            if (slideLink) {
                window.location.href = slideLink.href;
            }
        }, false);
    });
})

//show more
document.addEventListener('DOMContentLoaded', function() {
  const contents = document.querySelectorAll('.show-more-content');
  
  contents.forEach(content => {
    if (!content.closest('.show-more-container')) {
      const container = document.createElement('div');
      container.className = 'show-more-container';
      
      content.parentNode.insertBefore(container, content);
      container.appendChild(content);
      
      const toggleButton = document.createElement('button');
      toggleButton.className = 'show-more-toggle';
      toggleButton.innerHTML = `
        <span class="show-more-text">Show More ↓</span>
        <span class="show-less-text">Show Less ↑</span>
      `;
      container.appendChild(toggleButton);
      
      content.classList.add('collapsed');
      
      let contentHeight = content.scrollHeight;
      if (contentHeight > 1000) {
        contentHeight = contentHeight * 2;
      }
      content.style.setProperty('--content-height', (contentHeight + 20) + 'px');
      
      if (contentHeight <= 100) {
        toggleButton.style.display = 'none';
        content.classList.remove('collapsed');
        content.style.maxHeight = 'none';
      } else {
        toggleButton.addEventListener('click', function() {
          content.classList.toggle('collapsed');
        });
      }
    }
  });
});

//info table column hover
document.querySelectorAll('.response-table-wrap').forEach((container) => {
  container.querySelectorAll('.dl-info-table td, .dl-info-table th').forEach((cell) => {
      cell.addEventListener('mouseenter', function() {
          const index = Array.from(cell.parentNode.children).indexOf(cell);
          container.querySelectorAll(`.dl-info-table tr`).forEach((row) => {
              if (row.children[index]) row.children[index].classList.add('highlight');
          });
      });

      cell.addEventListener('mouseleave', function() {
          const index = Array.from(cell.parentNode.children).indexOf(cell);
          container.querySelectorAll(`.dl-info-table tr`).forEach((row) => {
              if (row.children[index]) row.children[index].classList.remove('highlight');
          });
      });
  });
});

// Product Description Toggle
document.addEventListener('DOMContentLoaded', function() {
    const productDescriptions = document.querySelectorAll('.product-short-description');
    
    productDescriptions.forEach(description => {
        const toggleBtn = description.querySelector('.product-description-toggle-btn');
        const content = description.querySelector('.product-description-content');
        const toggleText = toggleBtn.querySelector('.toggle-text');
        const toggleArrow = toggleBtn.querySelector('.toggle-arrow');
        
        if (!toggleBtn || !content) return;
        
        let isExpanded = true;
        const fullHeight = content.scrollHeight;
        
        if (fullHeight <= 115) {
            toggleBtn.style.display = 'none';
            return;
        }
        
        content.style.maxHeight = fullHeight + 'px';
        
        toggleBtn.addEventListener('click', function() {
            if (isExpanded) {
                // Collapse
                content.classList.add('collapsed');
                content.style.maxHeight = '115px';
                toggleText.textContent = 'show more';
                toggleArrow.classList.add('rotated');
                isExpanded = false;
            } else {
                // Expand
                content.classList.remove('collapsed');
                content.style.maxHeight = fullHeight + 'px';
                toggleText.textContent = 'show less';
                toggleArrow.classList.remove('rotated');
                isExpanded = true;
            }
        });
    });

    //crisp open chat
    const chatBtnEles = document.querySelectorAll('.open-chat, .button:has(.open-chat)');
    chatBtnEles.forEach(chatBtnEle => {
        chatBtnEle.addEventListener('click', function(e) {
            $crisp.push(['do', 'chat:open']);
            e.preventDefault();
            e.stopPropagation();
        });
    });
});